import React from "react";
import { InputGroup, Button, Input } from "reactstrap";

const FilterComponent = ( { filterText, onFilter, onClear ,component, showExport, onExport} ) => (
    
  <>
    <InputGroup size = "sm" className="mb-3" style = { { width: "35%", marginRight: "10px" } }>
      <Input 
      id = "search"
      type = "text"
      placeholder = "Search..."
      value = { filterText }
      onChange = { onFilter }
      />
      <Button color="primary" onClick = { onClear }>      
        <i className="pe-7s-close" style = { { cursor: "pointer", fontWeight: "bold"} }></i>
      </Button>
    </InputGroup>
    {showExport && (
      <InputGroup size="sm" className="mb-3" style={{ width: "10%" }}>
        <Button color="primary" onClick={onExport}>
          Export All
        </Button>
      </InputGroup>
    )}
    {component}
  </>
);

export default FilterComponent;
